export var StatusTypes;
(function (StatusTypes) {
  StatusTypes['UNAVAILABLE'] = 'UNAVAILABLE';
  StatusTypes['READY'] = 'READY';
  StatusTypes['CONNECTING'] = 'CONNECTING';
  StatusTypes['QUEUED'] = 'QUEUED';
  StatusTypes['CONNECTED'] = 'CONNECTED';
  StatusTypes['DISCONNECTED'] = 'DISCONNECTED';
  StatusTypes['ERROR'] = 'ERROR';
  StatusTypes['RECONNECTING'] = 'RECONNECTING';
})(StatusTypes || (StatusTypes = {}));
//# sourceMappingURL=events-models.js.map
